import { CRUDEventType, EventScope } from '@bimdata/definitions/const';
import { Model, ModelEvent } from '@bimdata/definitions/dto';
import { onModelsReplace, onModelsRemove } from '@/actions/model';
import * as api from '@/api/model';
import { Logger } from '@bimdata/client';
import stats from '@/loaders/project/classification.loader';

const getModelData = async (code: string, id: number): Promise<null | Model> => {
  try {
    return await api.get(code, id);
  } catch (err) {
    Logger.error(err);
  }
  return null;
}

export class EventQueue {

  private queues: Map<string, Map<CRUDEventType.UPDATE | CRUDEventType.DELETE, Map<number, ModelEvent>>>;

  constructor() {
    this.queues = new Map();
  }

  enqueue = (event: ModelEvent) => {
    if (event.scope === EventScope.MODEL) {
      if (!this.queues.has(event.data.projectCode)) {
        this.queues.set(event.data.projectCode, new Map());
      }
      const pq = this.queues.get(event.data.projectCode)!;
      const t = (event.type === CRUDEventType.CREATE) ? CRUDEventType.UPDATE : event.type;
      if (!pq.has(t)) {
        pq.set(t, new Map());
      }
      const tq = pq.get(t)!;
      tq.set(event.data.modelId, event);
      if (t === CRUDEventType.DELETE) {
        pq.get(CRUDEventType.UPDATE)?.delete(event.data.modelId);
      }
    }
  }

  async apply(): Promise<void> {
    for (const pq of this.queues.values()) {
      for (const tq of pq.values()) {
        for (const event of tq.values()) {
          switch (event.type) {
            case CRUDEventType.CREATE:
            case CRUDEventType.UPDATE: {
              const model = await getModelData(event.data.projectCode, event.data.modelId);
              if (model) {
                onModelsReplace(event.data.projectCode, [model]);
              } else {
                onModelsRemove(event.data.projectCode, [event.data.modelId]);
              }
            } break;
            case CRUDEventType.DELETE:
              onModelsRemove(event.data.projectCode, [event.data.modelId]);
              break;
          }
          stats();
        }
        tq.clear();
      }
      pq.clear();
    }
    this.queues.clear();
  }
  
}